"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _ListSelector = _interopRequireDefault(require("./ListSelector"));

var _buttonControl = _interopRequireDefault(require("../button-control"));

var _UserList = _interopRequireDefault(require("./UserList"));

var DynamicUserList = function DynamicUserList(_ref) {
  var header = _ref.header,
      buttonTitle = _ref.buttonTitle,
      icon = _ref.icon,
      onUserClick = _ref.onUserClick,
      _ref$newStyle = _ref.newStyle,
      newStyle = _ref$newStyle === void 0 ? false : _ref$newStyle,
      align = _ref.align,
      fetchUrl = _ref.fetchUrl,
      feature = _ref.feature,
      placeholder = _ref.placeholder,
      hasModal = _ref.hasModal;
  return (0, _preact.h)("div", {
    className: newStyle ? 'dynamic-user-list' : ''
  }, (0, _preact.h)(_DropdownControl.default, {
    align: "adjust",
    triggerClass: icon && typeof icon === 'string' ? icon : 'dropdown-wrapper',
    trigger: (0, _preact.h)(_buttonControl.default, {
      icon: icon,
      title: buttonTitle,
      newStyle: newStyle,
      size: newStyle ? 'medium' : 'small',
      class: "qa-topic-moderation-".concat(feature, " topic-moderation-").concat(feature)
    }),
    items: [],
    onTriggerClicked: function onTriggerClicked(_ref2) {
      var close = _ref2.close;
      return (0, _preact.h)(_ListSelector.default, {
        align: align,
        isDynamic: true,
        header: header(close),
        hasSearch: true,
        fetchUrl: fetchUrl,
        placeholder: placeholder,
        feature: feature
      }, function (users) {
        return (0, _preact.h)("div", null, hasModal ? (0, _preact.h)(_UserList.default, {
          users: users,
          onClick: onUserClick
        }) : (0, _preact.h)(_UserList.default, {
          users: users,
          onClick: /*#__PURE__*/function () {
            var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(user) {
              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return onUserClick(user).then(function () {
                        return close();
                      });

                    case 2:
                      return _context.abrupt("return", _context.sent);

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }()
        }));
      });
    }
  }));
};

var _default = DynamicUserList;
exports.default = _default;